<template>
  <div>
    <div class="head">
      <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
          :data="riskDistList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column label="安全风险" align="center" prop="riskInfo.riskInfo"/>
        <el-table-column label="风险等级" align="center" prop="riskLevel">
          <template slot-scope="scope">
            <el-link>{{ handleType(scope.row.riskLevel) }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="辨识时间" align="center" type="datetime" prop="distTime" width="180">
          <template slot-scope="{ row }">
            <span v-if="row.distTime">{{ row.distTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="center" prop="creator"/>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>

    <!-- 添加或修改风险四色图管理对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="安全风险" prop="riskId">
          <el-select v-model="form.riskId" placeholder="请选择安全风险">
            <el-option
                v-for="dict in riskInfoList"
                :key="dict.riskId"
                :label="dict.riskInfo"
                :value="dict.riskId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风险等级" prop="riskLevel">
          <el-select v-model="form.riskLevel" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in riskLevelArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="辨识时间" prop="distTime">
          <el-date-picker clearable
                          v-model="form.distTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择辨识时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="危害因素" prop="hazardType">
          <el-select v-model="form.hazardType" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in hazardTypeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="评估工具" prop="assessType">
          <el-select v-model="form.assessType" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in assessTypeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="分值" prop="assessScore">
          <el-input v-model="form.assessScore" placeholder="请输入分值"/>
        </el-form-item>
        <el-form-item label="创建人" prop="creator">
          <el-input v-model="form.creator" placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="数据对接省厅" prop="isTest">
          <el-select v-model="form.isTest" style="width: 100%">
            <el-option :value="1" label="否"/>
            <el-option :value="0" label="是"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {addRiskDist, delRiskDist, getRiskDist, listRiskDist, updateRiskDist} from "@/api/doublePrevention/riskDist";
import {listRiskInfo} from "@/api/doublePrevention/riskInfo";

export default {
  name: 'RiskDist',
  data() {
    return {
      // searchContent: '',
      riskDistList: [],
      riskInfoList: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null,
      riskLevelArr: [
        {
          label: "重大风险",
          value: "E4301"
        },
        {
          label: "较大风险",
          value: "E4302"
        },
        {
          label: "一般风险",
          value: "E4303"
        },
        {
          label: "低风险",
          value: "E4304"
        }
      ],
      hazardTypeArr: [
        {
          label: "个人因素",
          value: 1
        },
        {
          label: "物理因素",
          value: 2
        },
        {
          label: "环境因素",
          value: 3
        },
        {
          label: "管理因素",
          value: 4
        }
      ],
      assessTypeArr: [
        {
          label: "直接判定法",
          value: 1
        },
        {
          label: "作业条件危害分析法（LEC)",
          value: 2
        },
        {
          label: "风险矩阵分析法（LS)",
          value: 3
        },
        {
          label: "风险程度分析法（MES)",
          value: 4
        }
      ]
    }
  },
  created() {
    this.getRiskDistList();
    this.getRiskInfoList();
  },
  methods: {
    getRiskDistList() {
      listRiskDist({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.riskDistList = res.body.data
        this.total = res.body.cum
      })
    },
    getRiskInfoList() {
      listRiskInfo({limit: 100, curPage: 1, type: 0, isPage: 1}).then(res => {
        this.riskInfoList = res.body.data
      })
    },
    handleType(type) {
      let list = this.riskLevelArr.filter(item => item.value === type)
      return list[0].label
    },
    pageChange(val) {
      this.curPage = val;
      this.getRiskDistList();
    },
    addBtn() {
      this.reset()
      this.open = true
      this.title = '添加安全风险辨识记录信息'

    },
    editBtn(row) {
      this.reset()
      const riskDistId = row.riskDistId
      getRiskDist(riskDistId).then(response => {
        this.form = response.body.data
        this.open = true
        this.title = '修改安全风险辨识记录信息'
      })
    },
    deleteBtn(row) {
      delRiskDist(row.riskDistId).then(res => {
        this.$message.success('删除成功')
        this.getRiskDistList()
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        riskDistId: null,
        enterpriseId: null,
        riskId: null,
        riskLevel: null,
        distTime: null,
        companyCode: null,
        createTime: null,
        creator: null,
        recordStatus: null,
        isTest: null,
        hazardType: null,
        assessType: null
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.riskDistId != null) {
            updateRiskDist(this.form).then(response => {
              this.open = false
              this.$message.success('修改成功')
              this.getRiskDistList()
            })
          } else {
            addRiskDist(this.form).then(response => {
              this.open = false
              this.$message.success('新增成功')
              this.getRiskDistList()
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}

.btn {
  cursor: pointer;
}
</style>
